import axios from 'axios';

// 优先使用环境变量中的 VUE_APP_BASE_API
const BASE_URL = process.env.VUE_APP_BASE_API || '';

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可在此处添加token等
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
);

export default service; 